import { Color } from '../../../core/enums';

export const getColor = (color: Color) => {
  switch (color) {
    case Color.DeepBlue:
      return '#00175A';
    case Color.White:
      return '#FFFFFF';
    case Color.Black:
      return '#000000';
    case Color.Gray01:
      return '#F7F8F9';
    case Color.Gray02:
      return '#ECEDEE';
    case Color.Gray03:
      return '#C8C9C7';
    case Color.Gray04:
      return '#97999B';
    case Color.Gray05:
      return '#53565A';
    case Color.Gray06:
      return '#333333';
    case Color.Red:
      return '#B42C01';
    case Color.Green:
      return '#008767';
    case Color.StatusSuccess:
      return '#008767';
    case Color.StatusAttention:
      return '#FDB92D';
    case Color.StatusModerate:
      return '#EA700B';
    case Color.StatusWarning:
      return '#B42C01';
    case Color.Transparent:
      return 'transparent';
    default:
      return '#006FCF';
  }
};
